import { ButtonModule } from "primeng/button";
import { AvatarModule } from 'primeng/avatar';
import { MenuModule } from 'primeng/menu';
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { MessageModule } from "primeng/message";
import { InputIconModule } from "primeng/inputicon";
import { IconFieldModule } from "primeng/iconfield";
import { PasswordModule } from "primeng/password";
import { CheckboxModule } from "primeng/checkbox";

import { PopoverModule } from 'primeng/popover';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { RippleModule } from 'primeng/ripple';
import { DialogModule } from 'primeng/dialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { TabsModule } from 'primeng/tabs';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { MultiSelectModule } from 'primeng/multiselect';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { ProgressBar } from 'primeng/progressbar';
import { SelectModule } from 'primeng/select';
import { TagModule } from 'primeng/tag';
import { FileUploadModule } from 'primeng/fileupload';
import { DatePickerModule } from 'primeng/datepicker';
import { ChipModule } from 'primeng/chip';
import { FluidModule } from 'primeng/fluid';
import { PaginatorModule } from 'primeng/paginator';
import { StepperModule } from 'primeng/stepper';
import { SpeedDialModule } from 'primeng/speeddial';





export const primengImports = [
  ButtonModule,
  AvatarModule,
  MenuModule,
  CardModule,
  InputTextModule,
  MessageModule,
  InputIconModule,
  IconFieldModule,
  PasswordModule,
  CheckboxModule,
  PopoverModule,
  AvatarGroupModule,
  RippleModule,
  DialogModule,
  ProgressSpinnerModule,
  TableModule,
  TooltipModule,
  TabsModule,
  ToggleSwitchModule,
  MultiSelectModule,
  AutoCompleteModule,
  ProgressBar,
  SelectModule,
  TagModule,
  FileUploadModule,
  DatePickerModule,
  ChipModule,
  FluidModule,
  PaginatorModule,
  StepperModule,
  SpeedDialModule
];
